import {Injectable} from '@angular/core';
import {ApiService} from '@abstract/api.service';

/**
 * API заключений элементов технических устройств
 */
@Injectable()
export class ConclusionApiService extends ApiService {
    baseUrl = 'conclusion';

    /**
     * POST запрос генерации документов заключений.
     * Data:
     * {
     *     ids: number[]
     * }
     */
    public generateConclusionDocumentUrl = this.baseUrl + '/generate-conclusion-document';

    /**
     * Путь до получения оборудования для заключения
     * @param conclusionId
     */
    getEquipmentPath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/equipments`;
    }

    /**
     * Путь до сохранения файла скана заключения
     * @param conclusionId
     */
    getScanFormPath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/scan`;
    }

    /**
     * Путь до получения динамических параметров дефектов
     * @param conclusionId
     */
    getDefectParamsPath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/defect-params`;
    }

    /**
     * Путь до получения значений испытаний для заключения
     * @param conclusionId
     */
    getInspectionsPath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/inspections`;
    }

    /**
     * Путь до получения динамических параметров испытаний
     * @param conclusionId
     */
    getInspectionParamsPath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/inspection-params`;
    }

    /**
     * Путь до получения параметров, необходимых для создания испытаний
     * @param conclusionId
     */
    getInspectionBatchParamsPath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/inspection-batch-params`;
    }

    /**
     * Путь для создания испытаний заключения
     * @param conclusionId
     */
    getInspectionBatchCreatePath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/inspection-batch-create`;
    }

    /**
     * Путь для генерации документа заключения
     * В ответ присылает ссылку, по которой можно скачать файл
     */
    getDocumentGeneratePath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/generate-document`;
    }

    /**
     * Путь для получения списка доступных для выбора статусов испытаний и заключения
     * @param conclusionId
     */
    getStatusesPath(conclusionId: number): string {
        return `${this.baseUrl}/${conclusionId}/statuses`;
    }
}
